export const ALL_RESOURCES_FOLDER = "all";
export const TRASH_FOLDER = "trash";

export const STORAGE_UPGRADE_LINK = "https://share.hsforms.com/1ym9_HCz8QOS15vlRLKW1YQ3is1h";

export const RESOURCE_LINK_ALLOWED_URL_SCHEMES = ["https", "ftp"];
